import React, { useEffect, useState } from "react";
import SearchDropdown from "../components/SearchDropdown";
import { useAppLibs } from "../ContextProvider/AppLib_Provider.js";
import StudentProgressRecord from "../components/StudentProgress/StudentProgressRecord.jsx";
import Utils from "../utils/utils.js";
import Icon from "../utils/Icons.jsx";

const StudentProgress = ({ token }) => {
  const { Students } = useAppLibs();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const [students, setStudents] = useState([]);
  const [student, setStudent] = useState(null);
  const [isStudent, setIsStudent] = useState(false);
  const [batches, setBatches] = useState([]);
  const [batch, setBatch] = useState("");

  const fetchBatches = async (activeBatch) => {
    try {
      const response = await fetch(`${SERVER_URL}/batch/${activeBatch}`, {
        method: "GET",
        // mode: "cors",
        headers: {
          "Content-Type": "application/json",
          authorization: `${token}`,
        },
      });
      if (response.status === 200) {
        const res = await response.json();
        const onlyBatch = res.map((batch) => batch.batch);
        setBatches(onlyBatch);
      } else {
        const res = await response.json();
        alert(res.message);
        // Handle other response codes or errors here
        console.error("Data Retreieval:", res.message);
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error("Retreieval failed:", error);
    }
  };

  useEffect(() => {
    fetchBatches("PGP");
  }, []);

  const handleSelect = (selected) => {
    setStudent(selected);
  };

  const fetchStudents = async (batch) => {
    const query = {
      batch: batch,
    };
    const result = await Students.getStudents(query);
    if (result.success) {
      setStudents(result.data);
    } else {
      console.error("Error:", result.error);
    }
  };
  useEffect(() => {
    if (!batch) return;
    fetchStudents(batch);
  }, [batch]);

  useEffect(() => {
    if (student) {
      setIsStudent(true);
    } else {
      setIsStudent(false);
    }
  }, [student]);

  return (
    <div
      className="shadow-none p-4 overflow-y-auto h-[calc(100vh-65px)]"
      bkl="StudentProgress"
    >
      <div className="flex xs:flex-col xs:gap-y-2 justify-between">
        {student ? (
          <div className="flex items-center gap-1 just">
            <div
              className={`h-7 w-7 rounded-full flex items-center justify-center overflow-hidden ${
                student.name ? Utils.getRandomBgColor() + " text-white" : ""
              }`}
            >
              {student.name ? (
                Utils.getUserAvatar(student.name)
              ) : (
                <Icon.User className="w-4 h-4" />
              )}
            </div>
            <div className="font-semibold text-sm text-gray-600">
              {student.name}
            </div>
          </div>
        ) : (
          <div></div>
        )}

        <div className="flex gap-2">
          <label className="form-control">
            <select
              name="batch"
              value={batch}
              className="select select-sm px-2 xs:text-sm py-1 h-auto outline-gray-300 outline-1 focus:border-pink-500 outline focus:outline-none"
              onChange={(e) => setBatch(e.target.value)}
            >
              <option
                value={""}
                key={"Select-batch"}
                disabled
                style={{ fontWeight: "bold", color: "black" }}
              >
                Select Batch
              </option>
              {batches &&
                batches.map((batch, i) => (
                  <option value={batch} key={batch + i}>
                    {batch}
                  </option>
                ))}
            </select>
          </label>
          {students.length > 0 && (
            <SearchDropdown
              options={students}
              onSelect={handleSelect}
              batch={batch}
            />
          )}
        </div>
      </div>
      <div>
        {student ? (
          isStudent && <StudentProgressRecord student={student} />
        ) : (
          <div className="w-full mx-auto mt-6 max-w-md bg-white p-4 rounded-lg shadow-md text-center">
            <p className="text-gray-500 text-lg">
              Please select a student to track progress
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentProgress;
